import { render, staticRenderFns } from "./InvoiceNew_Details.vue?vue&type=template&id=5cc5463e&"
import script from "./InvoiceNew_Details.vue?vue&type=script&lang=js&"
export * from "./InvoiceNew_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports